import { render, staticRenderFns } from "./ProductEditControl.vue?vue&type=template&id=271582da&"
import script from "./ProductEditControl.vue?vue&type=script&lang=js&"
export * from "./ProductEditControl.vue?vue&type=script&lang=js&"
import style0 from "./ProductEditControl.vue?vue&type=style&index=0&id=271582da&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports